import { DateTime } from 'luxon';
import { decamelizeKeys } from '../../lib';
import {
    RentalIndexReferenceMonthsSnapshot,
    RentalPriceIndexSnapshot,
} from '../../models/RentalPayment';
import api from '../api';
import { getBackVersion } from '../../config';

const getIndexReferenceMonths =
    (): Promise<RentalIndexReferenceMonthsSnapshot> => {
        return api.request<RentalIndexReferenceMonthsSnapshot>({
            method: 'GET',
            url: `${getBackVersion()}/agent/rental/price_indexes/reference_months`,
        });
    };

const getPriceIndexes = (
    startDate: DateTime,
    endDate: DateTime
): Promise<RentalPriceIndexSnapshot[]> => {
    return api.request<RentalPriceIndexSnapshot[]>({
        method: 'GET',
        params: decamelizeKeys({
            startDate: startDate.toISODate(),
            endDate: endDate.toISODate(),
        }),
        url: `${getBackVersion()}/agent/rental/price_indexes`,
    });
};

export { getIndexReferenceMonths, getPriceIndexes };
